var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwardsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 180,
    viewBox: "0 0 186 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 95.5,
    cy: 90.5,
    r: 70.5,
    fill: "url(#paint0_linear_124_9426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M116.926 104.918L108.694 89.6943C109.533 87.7882 110.003 85.6816 110.003 83.4654C110.003 74.9238 103.079 68 94.5378 68C85.9949 68 79.071 74.9245 79.071 83.4654C79.071 85.7351 79.5641 87.8888 80.4419 89.83L72.1732 104.911C71.9066 105.395 71.9509 105.993 72.2843 106.436C72.6184 106.877 73.1825 107.084 73.7212 106.957L80.7822 105.338L83.1989 112.069C83.3874 112.592 83.865 112.955 84.4186 112.996C84.4545 112.999 84.4889 113 84.5226 113C84.777 113 85.0266 112.931 85.2448 112.8C85.463 112.67 85.6418 112.482 85.762 112.258L92.958 98.8514C93.4827 98.9045 94.0097 98.931 94.537 98.9308C95.0258 98.9308 95.5083 98.9055 95.9852 98.8605L103.337 112.269C103.467 112.506 103.663 112.701 103.902 112.83C104.14 112.959 104.411 113.016 104.681 112.995C105.233 112.951 105.708 112.589 105.895 112.068L108.312 105.337L115.373 106.957C115.915 107.088 116.473 106.877 116.807 106.438C117.143 105.999 117.188 105.404 116.926 104.918ZM84.7786 108.143L83.0089 103.213C82.7669 102.542 82.065 102.152 81.37 102.317L76.1476 103.515L82.1002 92.6582C84.0605 95.3063 86.8457 97.3038 90.0763 98.2759L84.7786 108.143ZM107.724 102.317C107.026 102.153 106.327 102.542 106.085 103.213L104.304 108.179L98.8899 98.3074C102.206 97.3361 105.059 95.2859 107.045 92.5604L112.973 103.521L107.724 102.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M99.7334 85.331C99.5263 85.5291 99.4311 85.8157 99.4783 86.0967L100.189 89.9806C100.249 90.3098 100.109 90.643 99.8294 90.8332C99.5559 91.0306 99.1919 91.0543 98.8935 90.8964L95.3508 89.0728C95.2276 89.0081 95.0908 88.9733 94.9509 88.9694H94.7341C94.6589 88.9804 94.5853 89.0041 94.5181 89.0404L90.9746 90.8727C90.7994 90.9595 90.601 90.9903 90.4067 90.9595C89.9331 90.8711 89.6172 90.4259 89.6947 89.9562L90.4067 86.0722C90.4538 85.7888 90.3587 85.5007 90.1515 85.2994L87.2631 82.5364C87.0215 82.3051 86.9375 81.9578 87.0479 81.6444C87.1551 81.3317 87.4286 81.1036 87.759 81.0523L91.7345 80.4831C92.0368 80.4523 92.3024 80.2708 92.4384 80.0024L94.1902 76.4579C94.2318 76.3789 94.2853 76.3063 94.3501 76.2447L94.4221 76.1895C94.4597 76.1484 94.5029 76.1145 94.5509 76.0868L94.6381 76.0553L94.7741 76H95.1108C95.4116 76.0308 95.6764 76.2084 95.8147 76.4737L97.5897 80.0024C97.7177 80.2605 97.9665 80.4397 98.2536 80.4831L102.229 81.0523C102.565 81.0997 102.846 81.3286 102.957 81.6444C103.062 81.9609 102.971 82.3083 102.725 82.5364L99.7334 85.331Z",
    fill: "#7456FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 178.461,
    cy: 27.5,
    r: 7.5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 20.0312,
    cy: 10,
    r: 10,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    cx: 10.0312,
    cy: 133,
    r: 5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    cx: 165.531,
    cy: 160.5,
    r: 2.5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    cx: 106.531,
    cy: 4.5,
    r: 2.5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    cx: 62.5312,
    cy: 176.5,
    r: 3.5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    cx: 122.031,
    cy: 171,
    r: 1,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    cx: 170.531,
    cy: 110.5,
    r: 2.5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    cx: 1.03125,
    cy: 75,
    r: 1,
    fill: "#A592FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_124_9426",
    x1: 166,
    y1: 161,
    x2: -1.77734,
    y2: 112.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6949FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#876DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardsIcon);
export default __webpack_public_path__ + "static/media/awardsIcon.eeeceed495fb31b7cae71035f0417e6f.svg";
export { ForwardRef as ReactComponent };